/* ============================================================
   Salty Seats - 2026 homepage behaviours.
   Product tabs, arrow-driven scroll tracks, and add to cart.
   ============================================================ */

(function () {
  'use strict';

  /* ---- product tabs ---------------------------------------- */

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sshm-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-sshm-panel]'));
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-sshm-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-sshm-panel') === key);
        });
        /* The newly shown track has never been measured, so its arrows
           are still in whatever state they were built with. */
        root.dispatchEvent(new CustomEvent('sshm:relayout'));
      });
    });
  }

  /* ---- arrow-driven scroll tracks -------------------------- */

  /* One page of scroll is the visible width minus a card's worth of
     overlap, so the card you were looking at stays partly in view and
     you never lose your place. */
  function initTracks(root) {
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-sshm-scroller]'));

    groups.forEach(function (group) {
      /* The shop has one track per tab inside a single group, so the
         track has to be resolved on every use - grabbing the first one
         once leaves the arrows driving a panel that is display:none,
         which measures zero and greys them both out. */
      var tracks = Array.prototype.slice.call(group.querySelectorAll('[data-sshm-track]'));
      var prev = group.querySelector('[data-sshm-prev]');
      var next = group.querySelector('[data-sshm-next]');
      if (!tracks.length) return;

      function live() {
        for (var i = 0; i < tracks.length; i++) {
          if (tracks[i].clientWidth > 0) return tracks[i];
        }
        return tracks[0];
      }

      function step(track) {
        var first = track.firstElementChild;
        var card = first ? first.getBoundingClientRect().width : 260;
        return Math.max(card, track.clientWidth - card * 0.35);
      }

      function sync() {
        var track = live();
        /* Sub-pixel track widths mean scrollLeft never quite reaches
           the arithmetic maximum - allow a pixel of slack at each end
           or the arrows never grey out. */
        var max = track.scrollWidth - track.clientWidth;
        var fits = max <= 1;
        if (prev) prev.disabled = fits || track.scrollLeft <= 1;
        if (next) next.disabled = fits || track.scrollLeft >= max - 1;
        group.classList.toggle('is-static', fits);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          var t = live();
          t.scrollBy({ left: -step(t), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          var t = live();
          t.scrollBy({ left: step(t), behavior: 'smooth' });
        });
      }

      tracks.forEach(function (t) {
        t.addEventListener('scroll', sync, { passive: true });
      });
      window.addEventListener('resize', sync);
      root.addEventListener('sshm:relayout', sync);
      sync();
    });
  }

  /* ---- marquee -------------------------------------------- */

  /* The keyframe translates the track by half its width, so the run of
     items has to be there twice for the loop to be seamless. Cloning it
     here keeps the duplicate out of the section's markup, where it
     would be read twice by screen readers. */
  function initMarquee(root) {
    root.querySelectorAll('[data-sshm-marquee]').forEach(function (track) {
      if (track.dataset.sshmCloned === '1') return;
      track.dataset.sshmCloned = '1';
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      while (clone.firstChild) track.appendChild(clone.firstChild);
    });
  }

  /* ---- add to cart ---------------------------------------- */

  function initCart(root) {
    root.querySelectorAll('[data-sshm-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var id = btn.getAttribute('data-sshm-add');
        if (!id) return;
        e.preventDefault();
        if (btn.disabled) return;

        var label = btn.textContent;
        var done = btn.getAttribute('data-added') || 'Added';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function () {
            btn.disabled = false;
            btn.textContent = done;
            document.dispatchEvent(
              new CustomEvent('cart:update', { bubbles: true, detail: { source: 'ss-home' } })
            );
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.open === 'function') drawer.open();
            setTimeout(function () { btn.textContent = label; }, 2200);
          })
          .catch(function () {
            /* Never leave the button dead. If the ajax add fails the
               product page can still take the order. */
            btn.disabled = false;
            btn.textContent = label;
            var href = btn.getAttribute('data-sshm-url');
            if (href) window.location.href = href;
          });
      });
    });
  }

  /* ---- boot ----------------------------------------------- */

  function init(root) {
    if (!root || root.dataset.sshmInit === '1') return;
    root.dataset.sshmInit = '1';
    initTabs(root);
    initTracks(root);
    initMarquee(root);
    initCart(root);
  }

  function boot() {
    document.querySelectorAll('.sshm').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('.sshm');
    if (root) init(root);
  });
})();
